import Vue from 'vue'
import VueRouter from 'vue-router'
import { authGuard } from "@/auth";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Base.vue'),
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Top',
        redirect: '/video',
      },
      {
        path: 'video',
        name: 'List',
        component: () => import('@/views/List.vue')
      },
      {
        path: 'video/new',
        name: 'New',
        component: () => import('@/views/Form.vue')
      },
      {
        path: 'video/edit/:uuid',
        name: 'Edit',
        props: true ,
        component: () => import('@/views/Form.vue')
      },
      {
        path: 'video/play/:uuid',
        name: 'Play',
        props: true ,
        component: () => import('@/views/Play.vue')
      },
    ]
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/views/Unauthorized.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router